import { uniq } from "ramda";

import buildAssetUrl from "./buildAssetUrl";

const fetchNestedAssetUrls = (items) => {
    const urls = getNestedAssetUrls(items);
    // console.log(`fetching ${urls.length} urls`)

    const fetchPromises = urls.map((url) => fetch(url).then((res) => res.arrayBuffer()));

    return Promise.all(fetchPromises);
};

const getNestedAssetUrls = (items) => {
    const urls = [];
    items.forEach((item) => {
        Object.keys(item).forEach((key) => {
            const value = item[key];
            traverse(key, value, urls);
        });
    });
    return uniq(urls);
};

const traverse = (key, value, urls) => {
    if (Array.isArray(value)) {
        return value.forEach((item) => traverse(key, item, urls));
    }

    const assetKeys = ["hotspotImage", "localizedHotspotImage", "asset", "localizedAsset"];

    if (assetKeys.indexOf(key) !== -1 && value !== null) {
        const { type, url } = buildAssetUrl(value);
        if (type === "image") {
            urls.push(url);
        }
        return;
    }

    if (key === "teaserImage" && value !== null) {
        const { type, url } = buildAssetUrl(value, 350);
        if (type === "image") {
            urls.push(url);
        }
    }

    if (value !== null && typeof value === "object") {
        return Object.keys(value).forEach((itemKey) => {
            const itemValue = value[itemKey];
            traverse(itemKey, itemValue, urls);
        });
    }
};

export default fetchNestedAssetUrls;



// WEBPACK FOOTER //
// ./src/utils/fetchNestedAssetUrls.js